import { render, staticRenderFns } from "./BackhaulProviderSummary.vue?vue&type=template&id=4bbec45e"
import script from "./BackhaulProviderSummary.vue?vue&type=script&lang=js"
export * from "./BackhaulProviderSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports